import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Card from "./views/Methods/cardView.vue";
import Store from "./views/Methods/storeView.vue";
import Netpay from "./views/Methods/netpayView.vue";
import Payu from "./views/Methods/payuView.vue";
import Paypalv from "./views/Methods/paypalView.vue";
import successNetpay from "./views/successNetpayView.vue";
import successPayu from "./views/successPayuView.vue";

Vue.use(Router);

export default new Router({
  routes: [{
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/card",
      name: "card",
      component: Card
    },
    {
      path: "/store",
      name: "store",
      component: Store
    },
    {
      path: "/npay",
      name: "npay",
      component: Netpay
    },
    {
      path: "/payu",
      name: "payu",
      component: Payu
    },
    {
      path: "/paypal",
      name: "paypal",
      component: Paypalv
    },
    {
      path: "/success",
      name: "successnpay",
      component: successNetpay
    },
    {
      path: "/successpayu",
      name: "successpayu",
      component: successPayu
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import( /* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});